// By importing CSCS here we get access to constants in CSCS
// and can add merc to CSCS
// but it's kind of circular

import {CSCS} from './CSCS.js';

// export let merc = {
CSCS.merc = {
  init : function() {
    // Local function. This is used by lcc also so probably should go in CSCS.js
    function msfnz(eccent, sinphi, cosphi) {
      var con = eccent * sinphi;
      return cosphi/(Math.sqrt(1.0 - con * con));
    }
    
    // deal with sphere
    if (Math.abs(this.a - this.b) < CSCS.EPSLN) {
      this.sphere = true;
    }    
    
    if (this.lat_ts) {
      if (this.sphere) {
        this.k0 = Math.cos(this.lat_ts);
      } else {
        this.k0 = msfnz(this.es, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
      }
    }
  },

  fwd : function(p) {
    var x, y, lon = p.x, lat = p.y, sinphi, ts;

    // Local function. This is used by lcc also so probably should go in CSCS.js
    function tsfnz(eccent, phi, sinphi) {
      var con = eccent * sinphi,
          com = 0.5 * eccent;
      con = Math.pow(((1.0 - con) / (1.0 + con)), com);
      return (Math.tan(0.5 * (CSCS.HALF_PI - phi))/con);
    }

    if (Math.abs( Math.abs(lat) - CSCS.HALF_PI) <= CSCS.EPSLN) {
      CSCS.ErrorMessage += "merc:forward: ll2mAtPoles";
      return; 
    } else {
      if (this.sphere) {
        x = this.x0 + this.a * this.k0 * CSCS.adjust_lon(lon - this.long0);
        y = this.y0 + this.a * this.k0 * Math.log(Math.tan(CSCS.FORTPI + 0.5 * lat));
      } else {
        sinphi = Math.sin(lat);
        ts = tsfnz(this.e,lat,sinphi);
        x = this.x0 + this.a * this.k0 * CSCS.adjust_lon(lon - this.long0);
        y = this.y0 - this.a * this.k0 * Math.log(ts);
      }
      p.x = x; 
      p.y = y;
      return p;
    }
  },

  inv : function(p) {
    var x = p.x - this.x0, y = p.y - this.y0, lon, lat, ts;
    
    // Local function. This is used by lcc also so probably should go in CSCS.js
    function phi2z(eccent, ts) { 
      var eccnth = 0.5 * eccent,
          con, dphi, i,
          phi = CSCS.HALF_PI - 2 * Math.atan(ts);
      for (i = 0; i <= 15; i++) {
        con = eccent * Math.sin(phi);
        dphi = CSCS.HALF_PI - 2 * Math.atan(ts *(Math.pow(((1.0 - con)/(1.0 + con)),eccnth))) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) {
          return phi;
        }
      }
      alert("phi2z has NoConvergence");
      return (-9999);
    }
    
    if (this.sphere) {
      lat = CSCS.HALF_PI - 2.0 * Math.atan(Math.exp(-y / this.a * this.k0));
    } else {
      ts = Math.exp(-y / (this.a * this.k0));
      lat = phi2z(this.e,ts);
      if (lat == -9999) {
        CSCS.ErrorMessage += "merc:inverse: lat = -9999";
        return null;
      }
    }
    lon = CSCS.adjust_lon(this.long0+ x / (this.a * this.k0));

    p.x = lon;
    p.y = lat;
    return p;
  }
};
